export const types = {
    login: '[Auth] login',
    loginFailure: '[Auth] login failure',
    logout: '[Auth] logout'
}